module.exports = __webpack_public_path__ + "img/icon-suma.474cc56d.svg";